import axios from "axios";
import { CRYPTO_TOKEN_SECRET_KEY, SOCKET_URL } from "./config";
import CryptoJS from "crypto-js";
import { decrypt, encrypt } from "./utils/encryptDecrypt";

const instance = axios.create({
  baseURL: SOCKET_URL, // Replace with your actual API base URL
});

instance.interceptors.request.use(
  (config) => {
    // Token Decryption
    const token = localStorage.getItem("token") ? CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8) : null;

    // IP Address Decryption
    const userEncryptData = localStorage.getItem("userData");
    const userDecryptData = userEncryptData ? CryptoJS.AES.decrypt(userEncryptData, CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8) : null;
    const userData = userDecryptData ? JSON.parse(userDecryptData) : {};
    const getIpAddress = userData?.ipAddress;

    // Add Authorization Header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add IP Address Header
    if (getIpAddress) {
      config.headers.ipAddress = getIpAddress;
    }

    // Add Domain URL Header
    const domainUrl = window.location.origin; // Gets the current domain
    if (domainUrl) {
      config.headers.domainurl = domainUrl;
    }

    // Encrypt Request Data (Exclude FormData)
    if (config.data && !(config.data instanceof FormData)) {
      config.data = encrypt(config.data);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      try {
        // Decrypt only the relevant `data` field
        const decryptedData = decrypt(response.data); // Assuming `decrypt` works on this structure
        response.data.data = JSON.parse(decryptedData); // Replace with decrypted data
      } catch (decryptionError) {
        console.error("Failed to decrypt response data:", decryptionError);
      }
    } else {
      console.warn("Response data is null or undefined.");
    }
    return response;
  },
  (error) => {
    const { response } = error;
    const jsonObject = error.response.data;
    if (response) {
      const statusCode = response.status;

      // Decrypt the error response data
      try {
        const encryptedData = response.data;
        if (encryptedData) {
          const decryptedData = CryptoJS.AES.decrypt(encryptedData, CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);

          response.data = JSON.parse(decryptedData);
        }
      } catch (decryptionError) {
        console.error("Failed to decrypt error response data:", decryptionError);
      }

      // Handle 401 Unauthorized
      const userEncryptData = localStorage.getItem("userData");
      const userDecryptData = userEncryptData ? CryptoJS.AES.decrypt(userEncryptData, CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8) : null;

      const userData = userDecryptData ? JSON.parse(userDecryptData) : {};
      const token = userData?.token;

      if (statusCode === 401) {
        if (token) {
          localStorage.clear(); // Clear all stored data
        } else {
          localStorage.clear(); // Also clear if no token exists
        }
        window.location.href = "/login";
      }
    }

    let decryptedData = decrypt(jsonObject);
    error.response.data = JSON.parse(decryptedData) ?? decryptedData;
    return Promise.reject(error);
  }
);

export default instance;

export const exchangerateApiURL = "https://v6.exchangerate-api.com/v6";
